<template>
  <LmDialog v-model="modalShow" :styles="{ minWidth: '400px' }" title="Create category">
    <template #toolbar-actions>
      <q-btn label="Save" color="tertiary" size="sm" @click="submit" />
    </template>
    <template #content>
      <q-card-section>
        <form @submit.prevent="submit">
          <div class="row q-col-gutter-md q-mb-md">
            <div class="col-xs-12">
              <q-input id="name" v-model="formData.name" type="text" label="Name" outlined />
            </div>
          </div>
        </form>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { cloneDeep, get } from 'lodash'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  name: 'CreateMetaDataCategoryForm',
  components: { LmDialog },
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      namespace: 'meta-data-categories',
      categoryCreated: false,
      formData: new LmFormObject({
        name: null
      }),
      style: {
        minWidth: '200px'
      }
    }
  },

  computed: {
    modalShow: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.closeModal()
      }
    }
  },

  methods: {
    prepareFormData() {
      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      return data
    },
    submit() {
      let formData = this.prepareFormData()
      this.categoryCreated = true
      let params = {
        namespace: `meta-data-categories`,
        value: formData
      }
      return this.$store.dispatch(`data/create`, params).then(result => {
        if (!get(result, 'errors')) {
          this.$emit('create', result)
          this.closeModal()
        }
      })
    },
    closeModal() {
      this.$emit('close')
      this.categoryCreated = false
      this.$set(this, 'formData', new LmFormObject(this.formData.originalData))
    }
  }
}
</script>
